<template>
  <v-container class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="right">Dnia {{(new Date().toJSON().slice(0, 10).replace(/(\d+)-(\d+)-(\d+)/, '$3-$2-$1'))}}</p>
<p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>
<br>

<table style="border: 1px solid; text-align: left;">
<tbody>

<tr>
<td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
<p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
</td>
<td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
<p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>Data</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{Data}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>Numer PESEL</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{pesel}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
</td>
</tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwo}}</span></p>
  </td>
  </tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>Numer telefonu</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>Adres e-mail</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{email}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>Adres zamieszkania</span><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{ zamieszkany }}, {{ kodPocztowy }}, {{ miejscowosc }}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>Adres korespondencyjny</span><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{korespondencyjny}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>Urząd Skarbowy (zgodny z adresem zamieszkania)</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{urzadSkarbowy}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
</td>
<td style="border: 1px solid;">
<p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
</td>
</tr>

<tr>
<td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
<p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
</td>
<td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
<p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</strong></span></p>
</td>
</tr>

<tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{emeryt}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{rencista}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia (nie dotyczy studiów doktoranckich, podyplomowych):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{student}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe (tylko w przypadku objęcia obowiązkowym ubezpieczeniem emerytalnym i rentowym):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę lub umowę zlecenie<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy/zleceniodawcy poza Tutore Poland Sp. z o.o. (proszę wypełnić w przypadku odpowiedzi TAK w pkt. 6):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie w innym miejscu niż Tutore Poland Sp. z o.o. jest wyższe bądź równe krajowej płacy minimalnej</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>
  <tr>

  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.3. Wnoszę o dobrowolne ubezpieczenie emerytalne i rentowe (tylko w przypadku odpowiedzi TAK w pkt. 6 i 6.2):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{dobrowolneUbezpieczenie}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu<br>niż umowa zlecenie z Tutore Poland Sp. z o.o. (np. zasiłek macierzyński, rodzicielski, urlop wychowawczy, własna pozarolnicza działalność gospodarcza):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

<tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table fs-14"><span><strong>
    Wypełnienie powyższego oświadczenia oznacza zgodę na podanie Tutore Poland Sp. z o.o. numeru telefonu, e-mail i adresu do korespondencji, jak również oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym, <br>
    oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.<br>
    W przypadku zmiany ww. danych w trakcie trwania umowy zlecenie, zobowiązuję się do poinformowania Zleceniodawcy w terminie 7 dni od daty zaistnienia zmiany.<br> Wszelkie szkody wynikające ze zmiany treści oświadczeń zobowiązuje się pokryć z własnych środków.
  </strong></span></p>
</td>
</tr>

</tbody>
</table>

</td></tr>
</tbody></table>
  </v-container>
</template>

<script>
export default {
  name: 'OswiadczenieGenerowanie2024',
  data () {
    return {
      Data: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      dobrowolneUbezpieczenie: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      urzadSkarbowy: '',
      tytulUbezpieczenieUmowaPraca: '',
      obywatelstwo: '',
      miejscowosc: '',
      kodPocztowy: '',
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

.fs-14 {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/OswiadczenieGenerowanie2024.vue